const getFormatedTime = (date, locale, formatOptions) =>
  date.toLocaleTimeString([locale], formatOptions);


export { 
  getFormatedTime
};



// WEBPACK FOOTER //
// ./src/components/utils/DateTime.js